import { Input } from "@/components/ui/input";
import "./StaffFilterInput.scss";

type StaffFilterInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

function StaffFilterInput({
  value,
  onChange,
  placeholder = "Filter staff…",
}: StaffFilterInputProps) {
  return (
    <div className="staff-filter-input">
      <Input
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        aria-label="Filter staff"
        className="staff-filter-input__field h-8 md:h-9 text-sm focus-visible:ring-0 focus-visible:ring-offset-0"
      />
    </div>
  );
}

export default StaffFilterInput;
